export const COLLAPSIBLE_CONFIRMATION_TYPES = new Set([
    'simple-confirmation',
    'confirmation-summary',
    'confirmation-hierarchy',
    'list-select',
    'list-select-multi',
    'numbered-list',
    'bulk-numbered-list',
    'bulk-confirmation',
    'sequenced-confirmation'
]);
export const ENRICHABLE_CONTENT_TYPES = [
    'applied',
    'dismissed',
    'bulk-applied'
];
// Must match the id ai-service appends in agentic-drafting-actor/agents/envelope/decorate.ts.
export const SOMETHING_ELSE_OPTION_ID = 'something-else';
